import type { FC } from 'react';
import { TermsAndConditionsWrapper } from './styled';
import { SWS_TERMS_AND_CONDITIONS } from '@/constants';

const TermsAndConditions: FC = () => {
  return (
    <TermsAndConditionsWrapper>
      <span>By using Simply Wall St you are agreeing to our </span>
      <a
        rel="noopener noreferrer"
        href={SWS_TERMS_AND_CONDITIONS}
        target="_blank"
        data-cy-id="link-terms-and-conditions"
      >
        terms and conditions
      </a>
      <span>. Simply Wall St provides general investment advice only.</span>
    </TermsAndConditionsWrapper>
  );
};

export default TermsAndConditions;
